import React from "react";
import { useTranslation } from "react-i18next";
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Box,
} from "@material-ui/core";
import { privacyPolicy, termsOfService } from "../../services/constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "80%",
    },
    termsLinks: {
      textDecoration: "none !important",
      color: theme.palette.dark.dark,
      fontWeight: "bold",
    },
    confirmationText: {
      fontSize: "0.8rem",
      lineHeight: "1rem",
    },
  })
);

export default function ConfirmPlanPolicy() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Typography className={classes.confirmationText}>
        {t("confirmation_policy")}{" "}
        <a
          className={classes.termsLinks}
          href={termsOfService}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("terms_of_service")}
        </a>
        {t("and_separator")}
        <a
          className={classes.termsLinks}
          href={privacyPolicy}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy")}
        </a>
      </Typography>
    </Box>
  );
}
